import _ from 'lodash';

export default class RequestTracker {
  constructor() {
    this.requests = [];
  }

  map(callback, thisArg) {
    return this.requests.map(callback, thisArg);
  }

  track(params) {
    // ensure each request is stored only once
    if (this.index(params) < 0) {
      this.requests.push(params);
    }
  }

  remove(params) {
    let index = this.index(params);
    if (index >= 0) {
      this.requests.splice(index, 1);
    }
  }

  index(searchParams) {
    return this.requests.findIndex(params => _.isEqual(params, searchParams));
  }

  reset() {
    this.requests = [];
  }
}



// WEBPACK FOOTER //
// ./src/scripts/adapters/gateways/lib/standard_gateway/request_tracker.js